import { createSelector } from 'reselect';
 
const selectOneSettings = (state: any) => state.oneSettings;
 
export const selectOneSettingsCurrentItem = createSelector([selectOneSettings], (oneSettings) => oneSettings.current);
 
export const selectOneSettingsListItems = createSelector([selectOneSettings], (oneSettings) => oneSettings.list);
 
 
export const selectOneSettingsItemById = (itemId: any) =>
    createSelector(selectOneSettingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectOneSettingsQueryItems = createSelector([selectOneSettings], (oneSettings) => oneSettings.query);

export const selectOneSettingsCreatedItem = createSelector([selectOneSettings], (oneSettings) => oneSettings.create);
 
export const selectOneSettingsUpdatedItem = createSelector([selectOneSettings], (oneSettings) => oneSettings.update);
 
export const selectOneSettingsReadItem = createSelector([selectOneSettings], (oneSettings) => oneSettings.read);
 
export const selectOneSettingsDeletedItem = createSelector([selectOneSettings], (oneSettings) => oneSettings.delete);
 
export const selectOneSettingsSearchedItems = createSelector([selectOneSettings], (oneSettings) => oneSettings.search);
 
export const selectOneSettingsItemsCount = createSelector([selectOneSettings], (oneSettings) => oneSettings.count);
 
export const selectOneSettingsItemsFilter = createSelector([selectOneSettings], (oneSettings) => oneSettings.filter);